// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { activityLogStyles } from "@sc/Overrides/Widgets/OrderApprovalDetails/ActivityLog";
import { fontConfig } from "@sc/XDL/PreStyle/typography";
import { css } from "styled-components";

activityLogStyles.changesAccordionSection = {
    toggleIconProps: {
        size: 20,
        color: "secondary.main",
        css: css`
            margin-left: auto;
            height: 24px;
            max-height: 24px;
        `,
    },
    panelProps: {
        css: css`
            padding: 0;
            border: none;
        `,
    },
    collapseIconProps: {
        size: 13,
    },
    expandIconProps: {
        size: 13,
    },
};

activityLogStyles.changesContainer = {
    css: css`
        width: 100%;
    `,
};

activityLogStyles.messageGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
        gap: 4px;
    `,
};

activityLogStyles.changesTitleWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

activityLogStyles.changesProductPriceText =
    activityLogStyles.changesProductQtyText =
    activityLogStyles.changesProductSubtotalText =
        {
            weight: fontConfig.weight.semiBold,
        };
